import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var SortIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 12 17" }),
        React.createElement("path", { d: "M2.42051 0.11625L0.124693 2.41206C-0.138626 2.67538 0.0424062 3.11973 0.412699 3.11973H1.88564V14.6399C1.88564 15.0925 2.25593 15.4628 2.70851 15.4628C3.16109 15.4628 3.53138 15.0925 3.53138 14.6399V3.11973H5.00432C5.37462 3.11973 5.55565 2.67538 5.29233 2.42029L2.99652 0.124479C2.84017 -0.0400951 2.57685 -0.0400953 2.42051 0.11625Z" }),
        React.createElement("path", { d: "M8.46862 1.47398V12.9942H6.99568C6.62538 12.9942 6.44435 13.4385 6.70767 13.6936L9.00348 15.9894C9.15983 16.154 9.42315 16.154 9.57949 15.9977L11.8753 13.7019C12.1386 13.4385 11.9576 12.9942 11.5873 12.9942H10.1144V1.47398C10.1144 1.0214 9.74407 0.651104 9.29149 0.651104C8.83891 0.651104 8.46862 1.0214 8.46862 1.47398Z" })));
};

export { SortIcon };
//# sourceMappingURL=SortIcon.esm.js.map
